import React from "react";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import PerfectScrollbar from "react-perfect-scrollbar";
import { ThreeDots } from "react-loader-spinner";
import PropTypes from "prop-types";

const WhatsHappeningCard = ({
  title,
  icon: Icon,
  content,
  isLoading,
  clientColor,
  classes,
  t,
  selectedSection,
  showStatusCircle = false,
  gridSize = { xs: 12, sm: 12, md: 3 },
  style = {},
}) => {
  const getStatusCircleStyle = () => {
    if (!selectedSection?.status) return {};

    const statusColors = {
      Green: {
        background: "linear-gradient(135deg, #66bb6a 0%, #43a047 100%)",
        boxShadow: "0 0 10px rgba(67,160,71,0.4)",
        hoverBoxShadow: "0 0 10px rgba(76,175,80,0.4)",
      },
      Red: {
        background: "linear-gradient(135deg, #ef5350 0%, #e53935 100%)",
        boxShadow: "0 0 10px rgba(229,57,53,0.4)",
        hoverBoxShadow: "0 0 10px rgba(244,67,54,0.4)",
      },
      Yellow: {
        background: "linear-gradient(135deg, #ffd54f 0%, #ffc107 100%)",
        boxShadow: "0 0 10px rgba(255,193,7,0.4)",
        hoverBoxShadow: "0 0 10px rgba(255,235,59,0.4)",
      },
    };

    const defaultStyle = {
      background: "linear-gradient(135deg, #bdbdbd 0%, #9e9e9e 100%)",
      boxShadow: "0 0 10px rgba(158,158,158,0.4)",
      hoverBoxShadow: "0 0 10px rgba(189,189,189,0.4)",
    };

    return statusColors[selectedSection.status] || defaultStyle;
  };

  const statusStyle = getStatusCircleStyle();

  return (
    <GridItem
      xs={gridSize.xs}
      sm={gridSize.sm}
      md={gridSize.md}
      style={{ display: "flex", padding: 0, margin: 0, ...style }}
    >
      <Card style={{ flex: 1, height: "90%" }}>
        <CardHeader
          color="client"
          icon
          style={{ position: "relative", paddingRight: "20px" }}
        >
          <CardIcon color="client">
            <Icon />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>{title}</h4>
          {showStatusCircle && (
            <div
              className={classes.statusCircle}
              style={{
                background: statusStyle.background,
                boxShadow: statusStyle.boxShadow,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.3)";
                e.currentTarget.style.boxShadow = statusStyle.hoverBoxShadow;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow = statusStyle.boxShadow;
              }}
            />
          )}
        </CardHeader>
        {isLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <ThreeDots
              color={clientColor}
              height={80}
              width={80}
              ariaLabel="loading"
            />
          </div>
        ) : (
          <CardBody
            className={classes.cardBody}
            style={{
              flex: 1,
              overflow: "auto",
              maxHeight: "calc(45vh - 100px)",
            }}
          >
            <PerfectScrollbar>
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    content ||
                    t("whatshappening.messages.no_message_available"),
                }}
                className={classes.textStyle}
              />
            </PerfectScrollbar>
          </CardBody>
        )}
      </Card>
    </GridItem>
  );
};

WhatsHappeningCard.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.elementType.isRequired,
  content: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  clientColor: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  selectedSection: PropTypes.object,
  showStatusCircle: PropTypes.bool,
  gridSize: PropTypes.object,
  style: PropTypes.object,
};

export default WhatsHappeningCard;
